export default {
  workers: (state = [], action) => {
    switch (action.type) {
      case 'setWorkers':
        return action.payload;

      default:
        return state;
    }
  },
};
